import { FC } from "react";
import { getCompletionPercent } from "../model/completionPercent";
import { getEligibilityText } from "../model/eligibilityText";
import type { Raffle, RaffleCompletion } from "../model/types";

import styles from "./RaffleProgress.module.css";

interface Props {
  raffle: Raffle;
}

const getHint = (completion: RaffleCompletion): string => {
  if (completion.is_participant) return "You're in the draw.";
  const left =
    Number(completion.volume_required_usdt) -
    Number(completion.volume_done_usdt);
  return `Trade ${Math.max(0, left).toFixed(2)} USDT more to participate.`;
};

// Выполнение условия по объёму и причина, если участвовать нельзя.
export const RaffleProgress: FC<Props> = ({ raffle }) => {
  const { completion } = raffle;
  const reason = getEligibilityText(raffle);
  const percent = getCompletionPercent(completion);

  return (
    <div className={styles.progress}>
      <div className={styles.header}>
        <span>Completed {percent}%</span>
        <span className={styles.volume}>
          {completion.volume_done_usdt} / {completion.volume_required_usdt} USDT
        </span>
      </div>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className={styles.bar} style={{ width: `${percent}%` }} />
      </div>
      <p className={reason ? styles.reason : styles.hint}>
        {reason ?? getHint(completion)}
      </p>
    </div>
  );
};
